import React from "react";

const BikeDetails = ({ setShowBikeDetails, riderDetails }: any) => {
  return (
    <div className="fixed z-40 inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50">
      <div className="bg-white p-4 rounded-md" style={{ width: "500px" }}>
        <div className="flex justify-between items-center  text-dark p-2 rounded-t-md mb-4">
          <h2 className="text-lg font-semibold">BIKE DETAILS</h2>
          <button
            onClick={() => setShowBikeDetails(false)}
            className="text-dark"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
        <div className="border-b border-gray-300 mb-8 flex justify-between">
          <h4 className="font-semibold">Bike Plate Number:</h4>{" "}
          <h5>{riderDetails.plateNo || "Unknown"}</h5>
        </div>
        <div className="border-b border-gray-300 mb-8 flex justify-between overflow-hidden">
          <h4 className="font-semibold">Bike Model/Color:</h4>{" "}
          <h5>{riderDetails.bikeModel || "Unknown"}</h5>
        </div>
      </div>
    </div>
  );
};

export default BikeDetails;
